import React, { ReactNode } from 'react';

interface Props {
    disabled?: boolean;
    children: ReactNode;
}

function ShowOnDisabled({ disabled, ...props }: Props) {
    if (!disabled) {
        return <div />;
    }
    return <>{props.children}</>;
}

export default ShowOnDisabled;
